<script>
// import { formatMonto } from "@/utils";

export default {
  name: "ColorTypeEmployee",
  props: {
    row: {
      type: Object,
      default: () => {}
    }
  },
  functional: true,

  // eslint-disable-next-line vue/require-render-return
  render(createElement, context) {
    // let { rowValue } = context.data.attrs;
    let { column } = context.data.attrs;
    let { row } = context.props;
    //console.log("context: ", context)

    let Type = String;
    let Status = String;
    let customStyle = String;

    if (
      Object.prototype.hasOwnProperty.call(row, "MotiveForDeletion") &&
      column === "MotiveForDeletion"
    ) {
      if (row.MotiveForDeletion == "Desahucio por parte del empleador") {
        Type = "Azul";
        Status = row.MotiveForDeletion;
        customStyle =
          "background-color:rgba(29, 255, 255, 0.1); padding-left: 25px; padding-right: 25px; padding-bottom: 15px; padding-top: 15px;";
      } else if (
        row.MotiveForDeletion == "Desahucio por parte del trabajador (Renuncia)"
      ) {
        Type = "Verde";
        Status = row.MotiveForDeletion;
        customStyle =
          "background-color:rgba(87, 255, 29, 0.1); padding-left: 25px; padding-right: 25px; padding-bottom: 15px; padding-top: 15px;";
      } else if (row.MotiveForDeletion == "Despido del trabajador") {
        Type = "Rojo";
        Status = row.MotiveForDeletion;
        customStyle =
          "background-color:rgba(255, 29, 29, 0.1); padding-left: 25px; padding-right: 25px; padding-bottom: 15px; padding-top: 15px;";
      } else if (row.MotiveForDeletion == "Dimisión del trabajador") {
        Type = "Negro";
        Status = row.MotiveForDeletion;
        customStyle =
          "background-color:rgba(255, 228, 29, 0.1); padding-left: 25px; padding-right: 25px; padding-bottom: 15px; padding-top: 15px;";
      } else {
        Type = "Negro";
        Status = "Sin Comentario";
        customStyle =
          "text-align: center; padding-left: 25px; padding-right: 25px; padding-bottom: 15px; padding-top: 15px;";
      }
      return createElement(
        "div",
        {
          attrs: {
            name: "",
            class: Type,
            style: customStyle,
            effect: "dark"
          }
        },
        Status
      );
    }
  }
};
</script>
<style scoped>
.Azul {
  color: blue;
}
.Verde {
  color: green;
}
.amarillo {
  background-color: #f5e10c;
}
.Naranja {
  color: orange;
}
.Rojo {
  color: rgba(255, 0, 0, 0.712);
}
.Negro {
  color: #606266;
}
</style>
